// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ef-0";
export var optionCard = "_ef-1";